'use client';

import React from 'react';
import FunctionalTableComponent from '../../../../components/table/FunctionalTableComponent';
import columns from './HousePriceTableConfig';
import fields from './HousePriceFormConfig';
import { useParams } from 'react-router-dom';

const PriceList = () => {
  let { id } = useParams();

  return (
    <>
      {/*<CardForm*/}
      {/*  title={'Cennik'}*/}
      {/*  fields={fields}*/}
      {/*  shadow={false}*/}
      {/*  width={10}*/}
      {/*  api={'house'}*/}
      {/*/>*/}

      <FunctionalTableComponent
        shadow={false}
        title={'Przypisane cenniki'}
        columns={columns}
        header={true}
        api={`house/${id}/price-list`}
        removable={true}
        modalSize={'md'}
        trick="Dla jednego domku nie można ustawić dwóch cenników na ten sam dzień."
        deleteApi={'house/price-list'}
        createApi={'house/price-list'}
        creationFields={fields}
        size={"sm"}
        deleteModalTitle={'Usunięcie cennika'}
        deleteModalDescription={'Czy na pewno chcesz usunąć cennik?'}
        editable={false}
        beforeSave={(data) => {
          data.houseId = id;
          return data;
        }}
        width={12}
      />
    </>
  );
};

export default PriceList;
